/**
 * @generated SignedSource<<bd9220da48c26380cca961494b86b189>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "uuid",
        "variableName": "uuid"
      }
    ],
    "concreteType": "PortfolioPropertyMember",
    "kind": "LinkedField",
    "name": "portfolioAddProperty",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioAddPropertyMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PortfolioAddPropertyMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "63ead8c0548fe17f1051578b9d0fe214",
    "id": null,
    "metadata": {},
    "name": "PortfolioAddPropertyMutation",
    "operationKind": "mutation",
    "text": "mutation PortfolioAddPropertyMutation(\n  $uuid: ID!\n  $input: PortfolioAddPropertyInput!\n) {\n  portfolioAddProperty(uuid: $uuid, input: $input) {\n    id\n    uuid\n  }\n}\n"
  }
};
})();

node.hash = "f705f02ff93060fb0ec6030254f7677c";

export default node;
